const inicialState = {
  fishFinalizada: false
};

export default inicialState;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.state.js